<script lang="ts" setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const navigate = (path: string) => {
  router.push(path);
};
</script>

<template>
  <v-container class="pt-16 card-list">
    <v-card class="mb-8 bg-primary card" @click="navigate('/stories')">
      <v-card-text>
        <h2>Stories</h2>
        <p>Manage content stories which lead to actions</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/quiz-of-the-day')">
      <v-card-text>
        <h2>Quiz of the day</h2>
        <p>Manage how stories show up in the quiz of the day</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/categories')">
      <v-card-text>
        <h2>Categories</h2>
        <p>Manage the categories</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/users')">
      <v-card-text>
        <h2>Users</h2>
        <p>Manage users</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/co2quiz')">
      <v-card-text>
        <h2>CO2 Quiz</h2>
        <p>Manage the questions for the CO2 quiz</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/bpt')">
      <v-card-text>
        <h2>BPT Questions</h2>
        <p>Manage the questions for the BPT scan</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/content')">
      <v-card-text>
        <h2>Content</h2>
        <p>
          Manage the content of the stories, questions, actions, info and hero
          pages
        </p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/learning')">
      <v-card-text>
        <h2>Learning</h2>
        <p>Manage the learning items</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/labels')">
      <v-card-text>
        <h2>Labels</h2>
        <p>
          Manage the labels that can be assigned to users which are used to
          personalize their experience
        </p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/data-tables')">
      <v-card-text>
        <h2>Data tables</h2>
        <p>Manage data used for co2 calculations.</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/feedback')">
      <v-card-text>
        <h2>Feedback</h2>
        <p>See feedback from users from the app</p>
      </v-card-text>
    </v-card>
    <v-card class="mb-8 bg-primary card" @click="navigate('/statistics')">
      <v-card-text>
        <h2>Statistics</h2>
        <p>See some statistics based on the data in the CMS.</p>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<style scoped>
.card-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.card {
  width: calc(33% - 16px);
  min-height: 120px;
  margin: 8px;
}
</style>
